<p i18n="@@shared.markdown-editor.explanation"><a href="https://commonmark.org/help/" target="_blank">Markdown</a> is used for layout. On the left you can enter markdown text, on the right there is a preview how it will be rendered</p>
<div class="markdown-wrap">
  <div class="textarea-wrap">
    <mat-form-field>
      <textarea matInput [formControl]="editorControl" cdkTextareaAutosize cdkAutosizeMinRows="6" cdkAutosizeMaxRows="30" #editor></textarea>
    </mat-form-field>
  </div>
  <div class="markdown-preview" [innerHTML]="htmlPreview$ | async" [class.info-panel-width]="useInfoPanelWidth"></div>
</div>
